import { render, staticRenderFns } from "./warehousePankuiReceipt.vue?vue&type=template&id=540f0e2c&scoped=true&"
import script from "./warehousePankuiReceipt.vue?vue&type=script&lang=js&"
export * from "./warehousePankuiReceipt.vue?vue&type=script&lang=js&"
import style0 from "./warehousePankuiReceipt.vue?vue&type=style&index=0&id=540f0e2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540f0e2c",
  null
  
)

export default component.exports